import type { AlfredStatus } from "./alfred.ts";

/** Lo que dice el diálogo de Alfred y sus adjuntos. */
export const ALFRED_TEXTS = {
  section: "Alfred",
  button: "Cuéntale a Alfred",
  command: "Cuéntale a Alfred lo que necesitas",
  title: "Cuéntale a Alfred lo que necesitas",
  description:
    "Una idea, algo que falta o algo que no funciona. Le avisamos por correo a quien atiende Alfred, y su estado lo sigues en Alfred, en el menú.",
  who: "Quién",
  subject: "Título",
  body: "Descripción",
  send: "Enviar",
  sending: "Enviando…",
  cancel: "Cancelar",
  close: "Cerrar",
  required: (field: string) => `Falta «${field}».`,
  thanks: "Listo: Alfred ya tiene tu pedido.",
  noConnection:
    "No se pudo enviar: no hay conexión con el servidor. Lo escrito sigue aquí.",
  /* Los adjuntos. */
  attachments: "Adjuntos",
  attach: "Adjuntar",
  attachHint: (paste: string) => `o pega una captura o un archivo con ${paste}`,
  remove: (name: string) => `Quitar ${name}`,
  uploading: "Subiendo…",
  uploaded: "Subido",
  uploadFailed: "No se subió",
  retryUploads: "Reintentar los adjuntos",
  done: "Terminar",
  savedButUploads: (count: number) =>
    count === 1
      ? "Lo escrito quedó guardado, pero un adjunto no se subió. Reintenta o quítalo."
      : `Lo escrito quedó guardado, pero ${String(count)} adjuntos no se subieron. Reintenta o quítalos.`,
} as const;

/** Con las palabras del equipo, las mismas del API. */
export const ALFRED_STATUS_LABELS: Record<AlfredStatus, string> = {
  new: "Nuevo",
  needs_info: "Necesita información",
  in_progress: "En progreso",
  delivered: "Entregado",
  cancelled: "Anulado",
};

/** Los avisos de por qué un archivo no se adjuntó. */
export const ALFRED_RULES_TEXTS = {
  type: (name: string) =>
    `«${name}» no se adjuntó: se aceptan imágenes, PDF, texto, CSV, Excel y Word.`,
  size: (name: string, size: string, max: string) =>
    `«${name}» no se adjuntó: pesa ${size} y el máximo son ${max}.`,
  count: (name: string, max: number) =>
    `«${name}» no se adjuntó: un pedido lleva hasta ${String(max)} adjuntos.`,
} as const;

/** Los nombres accesibles de los adjuntos ya guardados. */
export const ALFRED_LINK_TEXTS = {
  open: (name: string) => `Abrir ${name}`,
  remove: (name: string) => `Quitar ${name}`,
} as const;
